/**
 * Build-time environment marker.
 *
 * `VITE_ENV_LABEL` is empty in production builds, so production renders
 * nothing. Staging packages set it (for example `STAGING`) so the owner can
 * never mistake the acceptance-test environment for production.
 */
export function environmentLabel(): string {
  return (import.meta.env.VITE_ENV_LABEL ?? '').trim();
}

export function EnvironmentBadge({ className = '' }: { className?: string }) {
  const label = environmentLabel();
  if (!label) return null;

  return (
    <span
      role="status"
      aria-label={`${label} environment`}
      className={`inline-flex items-center rounded-md border border-amber-300 bg-amber-100 px-2 py-0.5 text-[11px] font-bold tracking-wide text-amber-800 uppercase ${className}`}
    >
      {label}
    </span>
  );
}
